// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-title {
  font-family: "Yanone Kaffeesatz";
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.3px;
}`, "",{"version":3,"sources":["webpack://./src/app/common/sharedComponents/overlay-header/overlay-header.component.scss"],"names":[],"mappings":"AAEI;EAEI,gCAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;AAFR","sourcesContent":["\r\n:host {\r\n    ion-title { \r\n        //text-align: center; per ora no, la presenza di tasti fa casino\r\n        font-family: 'Yanone Kaffeesatz';\r\n        text-transform: uppercase;\r\n        font-weight: 500;\r\n        letter-spacing: 0.3px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
